import React, { useState, memo } from 'react';
const faqs = [{
  q: '¿Sirve para niveles iniciales?',
  a: 'Sí, incluye tomos específicos desde U10 con progresiones graduales para cada categoría.'
}, {
  q: '¿El Kit Táctico es en video?',
  a: 'No, son herramientas visuales en PDF HD diseñadas para visualización rápida en tablet, móvil o impresas.'
}, {
  q: '¿Qué pasa si mis jugadores tienen niveles mezclados?',
  a: 'El sistema incluye variantes de complejidad para cada ejercicio, fáciles de adaptar al grupo que tengas en cancha.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato por email tras la compra. Todo en PDF descargable, listo para usar desde el primer entrenamiento.'
}, {
  q: '¿Sirve si soy principiante como entrenador?',
  a: 'Sí, está diseñado desde cero. Abres el tomo, lees 3 minutos y entras a la cancha con todo resuelto.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días sin preguntas. 100% de tu dinero de vuelta si no es lo que esperabas.'
}, {
  q: '¿Puedo usarlo en escuelas y clubes a la vez?',
  a: 'Sí. El material está pensado para clases de Educación Física y para entrenamientos de club. Las sesiones son adaptables a 40, 60 u 80 minutos.'
}, {
  q: '¿Necesito experiencia previa en handball para aplicarlo?',
  a: 'No. Cada ejercicio incluye objetivos, organización del espacio, variantes y puntos clave de corrección. Es un sistema guiado, paso a paso.'
}, {
  q: '¿Funciona en celular y tablet?',
  a: 'Sí, todos los PDF están optimizados para leerse en móvil, tablet o computadora. También podés imprimirlos en alta calidad para llevarlos a la cancha.'
}, {
  q: '¿Recibo actualizaciones futuras?',
  a: 'Sí. Una vez comprado, accedés gratis a las próximas mejoras y nuevas sesiones que sumemos al Megapack.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-105">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-106">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-107">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-108">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-109">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-110">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-111">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-112">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-113">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" data-id="element-114"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-115">
            🚀 ¡SÍ! QUIERO MEJORAR MI CARRERA AHORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-116">
            <span data-id="element-117">⚡ Acceso Inmediato</span>
            <span data-id="element-118">•</span>
            <span data-id="element-119">🛡️ Garantía de 7 Días</span>
          </p>
        </div>
      </div>
    </section>;
}